import React from 'react'
import { Link } from 'react-router-dom'

function ActionLink({ children, to }) {
  return (
    <div className="text-sm leading-5 text-gray-500 cursor-pointer font-semibold">
      <Link
        className="hover:text-gray-900 focus:outline-none focus:text-gray-900 transition duration-150 ease-in-out"
        to={to}
      >
        {children}
      </Link>
    </div>
  )
}

export default ActionLink
